import React from "react";
import PolicyPage, { ContactEmail } from "./PolicyPage";

function PromotionsPolicy() {
  return (
    <PolicyPage title="Promotions, Discounts & Gift Cards Policy">
      <h2>Promotion terms</h2>
      <p>Each promotion may have its own dates, eligible products, minimum spend, territory, redemption method, and exclusions. Those specific terms control if they conflict with this general policy. Promotions are void where prohibited.</p>

      <h2>Discount codes</h2>
      <p>Unless stated otherwise, one code may be used per order, codes cannot be combined, have no cash value, and do not apply to taxes, duties, or shipping. A code must be entered before payment and cannot normally be added after an order is placed.</p>

      <h2>Fair use</h2>
      <p>Offers are intended for the stated audience and personal use. We may reject or reverse a discount obtained through technical error, automation, false accounts, manipulation, unauthorized publication, or other abuse. If we cancel an affected order, amounts paid will be returned.</p>

      <h2>Price changes</h2>
      <p>Prices and promotions may change prospectively. A later lower price does not create an automatic price adjustment unless the specific promotion says otherwise. An obvious pricing error may be corrected under our Terms of Sale.</p>

      <h2>Gift cards and store credit</h2>
      <p>If offered, gift cards and store credits are electronic value, not bank accounts. They cannot be redeemed for cash except where law requires, may not be resold without permission, and should be protected like cash. Expiration and inactivity rules will follow applicable law and any terms shown at purchase.</p>

      <h2>Returns from promotional orders</h2>
      <p>Refunds reflect the amount actually paid. If a return makes the remaining order ineligible for a multi-item or threshold discount, the refund may be adjusted to reflect the promotion's terms where law allows. A free gift may need to be returned or its disclosed value deducted.</p>

      <h2>Contact</h2>
      <p>Promotion questions may be sent to <ContactEmail /> before purchase.</p>
    </PolicyPage>
  );
}

export default PromotionsPolicy;
